// extracted by mini-css-extract-plugin
module.exports = {"cta":"_z","cta__pageLink":"_A"};